import { render, staticRenderFns } from "./InProcessingClassModalComponent.vue?vue&type=template&id=6170e0e8&"
import script from "./InProcessingClassModalComponent.vue?vue&type=script&lang=ts&"
export * from "./InProcessingClassModalComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6170e0e8')) {
      api.createRecord('6170e0e8', component.options)
    } else {
      api.reload('6170e0e8', component.options)
    }
    module.hot.accept("./InProcessingClassModalComponent.vue?vue&type=template&id=6170e0e8&", function () {
      api.rerender('6170e0e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/InProcessingClass/InProcessingClassModalComponent.vue"
export default component.exports